import styled from "styled-components";

export const TitleStyle = styled.div`
  h1 {
    font-size: 1.5rem;
    font-weight: 900;
  }
`;

export const Underline = styled.div`
  height: 3px;
  width: 50px;
  background-color: var(--color-purple);
`;
